import config from 'config';
import * as actionTypes from './types';
export const initialState = {
    modalOpen: false,
    modalType: null,
    items: [],
    selectedItem: {
        firstName: '',
        lastName: '',
        email: '',
        mobileNum: '',
        jobTitleInCompany: '',
        profileImage: ''
    },
    permissions: {
        canCreateEvent: 1,
        canInviteTeamMembers: 0,
        canManageQuestion: 1,
        hasAdministrativeControl: 0
    },
    currentPage: 1,
    itemsPerPage: 12,
    paginationMeta: {},
    selectedId: window.localStorage.getItem('diologSelectedId'),
    reload: false,
    searchText: '',
    selectedProfileImage: ''
};
const MyTeamReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setModalOpen:
            return {
                ...state,
                modalOpen: action.modalOpen
            };
        case actionTypes.setModalType:
            return {
                ...state,
                modalType: action.modalType
            };
        case actionTypes.setItems:
            return {
                ...state,
                items: action.items
            };
        case actionTypes.setSelectedItem:
            return {
                ...state,
                selectedItem: action.selectedItem
            };
        case actionTypes.setTemplateType:
            return {
                ...state,
                templateType: action.templateType
            };
        case actionTypes.setCurrentPage:
            return {
                ...state,
                currentPage: action.currentPage
            };
        case actionTypes.setItemsPerPage:
            return {
                ...state,
                itemsPerPage: action.itemsPerPage
            };
        case actionTypes.setPaginationMeta:
            return {
                ...state,
                paginationMeta: action.paginationMeta
            };
        case actionTypes.setReload:
            return {
                ...state,
                reload: action.reload
            };
        case actionTypes.setPermissions:
            return {
                ...state,
                permissions: action.permissions
            };
        case actionTypes.setSelectedId:
            localStorage.setItem('diologSelectedId', action.selectedId);
            return {
                ...state,
                selectedId: action.selectedId
            };
        case actionTypes.setSearchText:
            return {
                ...state,
                searchText: action.searchText
            };
        case actionTypes.setSelectedProfileImage:
            return {
                ...state,
                selectedProfileImage: action.selectedProfileImage
            };
        default:
            return state;
    }
};

export default MyTeamReducer;
